import { e as error, j as json } from "../../../../chunks/index2.js";
import { randomUUID } from "crypto";
import { b as sendEmailVerification } from "../../../../chunks/mailer.js";
import { h as handleRequest } from "../../../../chunks/utils.js";
import { g as get, V as VerificationCodeCollection, U as UserCollection } from "../../../../chunks/firebase.js";
const GET = handleRequest(async ({ url, locals }) => {
  const { searchParams } = url;
  const email = searchParams.get("email");
  const code = searchParams.get("code");
  if (email && code) {
    const verificationCode = await get(VerificationCodeCollection(), email);
    if (verificationCode.data) {
      const isExpired = verificationCode.data.expires < Date.now();
      if (isExpired) {
        await verificationCode.ref.delete();
        return error(410, {
          message: "Verification code expired"
        });
      }
      const verified = verificationCode.data.code === code;
      if (verified) {
        await verificationCode.ref.delete();
        await UserCollection().doc(locals.user?.id).set({ email }, { merge: true });
      }
      return json({ verified }, { status: verified ? 200 : 403 });
    }
    return error(404, {
      message: "Verification code not found"
    });
  }
  if (email) {
    const id = randomUUID().split("-").join("");
    const code2 = id.substring(0, 6).toUpperCase();
    await VerificationCodeCollection().doc(email).set({ code: code2, expires: Date.now() + 1e3 * 60 * 5 });
    await sendEmailVerification(email, code2);
    return json({ success: true });
  }
  return error(400, {
    message: "No email provided"
  });
});
export {
  GET
};
